<template>
  <vx-card>
    <div class="orgs">
      <span>Sites</span>
    </div>
    <site-item
      :list="lists"
      @update:item="showBookmarkItem"
      @delete:item="confirmDelete"
    />
    <!-- Modal Bookmark -->
    <Modal
      :show="showBookmarkModal"
      :order="2"
      size="sm"
      centered
      :close-by-backdrop="false"
      @close="closeBookmarkModal"
    >
      <div class="bg-white flex flex-col rounded">
        <div class="px-4 pt-4">
          <span class="text-lg font-bold uppercase">Update Bookmark</span>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold">
            Selected Camera:
            <span class="text-black">
              {{ selectedBookmark.cameraName || "unknown" }}
            </span>
          </div>
          <div class="w-full h-px bg-grey my-4" />
          <p v-if="formError" class="text-red text-sm mb-2">
            {{ formError }}
          </p>
          <div class="flex flex-wrap -mx-4">
            <div class="w-full px-4 mb-3">
              <label for="date" class="block mb-2 font-medium">Name</label>
              <vs-input class="w-full" v-model="form.name" placeholder="Name" />
            </div>
            <div class="w-full px-4">
              <label for="date" class="block mb-2 font-medium"
                >Description</label
              >
              <vs-textarea
                v-model="form.description"
                placeholder="Description"
              />
            </div>
            <div class="w-full px-4 mb-3">
              <label for="date" class="block mb-2 font-medium"
                >Start Date</label
              >
              <flat-pickr
                class="vs-inputx vs-input--input normal"
                v-model="form.date"
                :config="dateConfig"
              />
            </div>
            <div class="w-1/2 px-4 mb-3">
              <label for="date" class="block mb-2 font-medium"
                >Start Time</label
              >
              <flat-pickr
                class="vs-inputx vs-input--input normal"
                v-model="form.startTime"
                :config="timeConfig"
                placeholder="Start time"
              />
            </div>
            <div class="w-1/2 px-4 mb-4">
              <label for="date" class="block mb-2 font-medium">End Time</label>
              <flat-pickr
                class="vs-inputx vs-input--input normal"
                v-model="form.endTime"
                :config="timeConfig"
                placeholder="End time"
              />
            </div>
            <div class="w-full h-px bg-grey my-4" />
            <div class="w-1/4 px-4">
              <label for="date" class="block font-medium">Duration</label>
              <strong>{{ bookmarkDuration }}</strong>
            </div>
            <div class="w-3/4 text-right px-4 space-x-2">
              <vs-button
                color="dark"
                type="flat"
                @click.native="closeBookmarkModal"
              >
                Cancel
              </vs-button>
              <vs-button
                color="primary"
                type="filled"
                :disabled="formLoading"
                @click.prevent="updateBookmark"
              >
                {{ formLoading ? "Submitting..." : "Update" }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </vx-card>
</template>

<script>
import { toDuration, GMTToLocalStringTime, getTime } from "@/composables";
import { dateConfig, timeConfig } from "@/views/views/states";
import api from "@/api";
import SiteItem from "./SiteItem.vue";
import Modal from "@/components/modal/Modal.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    SiteItem,
    Modal,
    flatPickr,
  },
  data: () => ({
    lists: [],
    selectedBookmark: {},
    formError: null,
    formLoading: false,
    showBookmarkModal: false,
    form: {
      name: "",
      description: "",
      date: "",
      startTime: "",
      endTime: "",
    },
    timeConfig,
    dateConfig,
  }),
  computed: {
    bookmarkDuration() {
      if (this.form.startTime && this.form.endTime) {
        return toDuration({
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        });
      }
      return "00:00:00";
    },
  },
  async mounted() {
    await this.getBookmarks();
  },
  methods: {
    getBookmarks() {
      this.$vs.loading();
      api
        .bookmarks()
        .then((result) => result.data)
        .then((data) => {
          // console.log(data)
          if (data.status) {
            this.lists = data.data;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    async confirmDelete({
      id,
      cameraId,
      name,
      description,
      endTime,
      startTime,
    }) {
      const ask = confirm("Are you sure will delete this data?");
      if (ask) {
        const params = {
          id: id,
          cameraId: cameraId,
          name: name,
          description: description,
          startTime: startTime,
          endTime: endTime,
        };
        try {
          this.$vs.loading();
          await api.bookmarkDelete(params);
          await this.getBookmarks();
          this.$vs.loading.close();
        } catch (error) {
          this.$vs.loading.close();
        }
      }
    },
    showBookmarkItem(bookmark) {
      this.showBookmarkModal = true;
      this.selectedBookmark = bookmark;
      // destruction of the bookmark
      const { name, description, startTime, endTime } = bookmark;
      // set to form
      this.form.name = name;
      this.form.description = description;
      this.form.date = new Date(startTime);
      this.form.startTime = getTime(startTime);
      this.form.endTime = getTime(endTime);
    },
    closeBookmarkModal() {
      this.showBookmarkModal = false;
      this.formError = null;
      this.selectedBookmark = {};
      for (const key in this.form) {
        this.form[key] = "";
      }
    },
    async updateBookmark() {
      try {
        this.formLoading = false;
        // validate all the fields
        const areValid = Object.values(this.form).every((value) => value);
        if (!areValid) {
          this.$vs.dialog({
            color: "warning",
            title: `Warning`,
            text: "Masih ada field yang kosong!",
            acceptText: "Close",
          });
          return;
        }
        // parsing date
        const date = new Date(this.form.date).toDateString();
        // to iso date format
        const isoStartTime = GMTToLocalStringTime(
          `${date} ${this.form.startTime}`
        );
        const isoEndTime = GMTToLocalStringTime(`${date} ${this.form.endTime}`);

        // set to params
        const params = {
          id: this.selectedBookmark.id,
          cameraId: this.selectedBookmark.cameraId,
          name: this.form.name,
          description: this.form.description,
          startTime: isoStartTime,
          endTime: isoEndTime,
        };

        // update
        await api.bookmarkUpdate(params);
        await this.getBookmarks();
        // set loading to false
        this.formLoading = false;
        // close modal
        this.closeBookmarkModal();
        // notify
        this.$vs.notify({
          title: "Success",
          text: "Bookmark successfully updated",
          color: "success",
          position: "top-right",
        });
      } catch (error) {
        throw new Error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.orgs {
  font-size: 24px;
  span {
    color: #1372ac;
    font-weight: 600;
  }
  padding-bottom: 20px;
}
</style>
